"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  sm: 360,
  md: 564,
  lg: 768,
  xl: 1024,
  max: 1280
};
exports["default"] = _default;